import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=b0cc5638"
import script from "./Goals.vue?vue&type=script&lang=ts"
export * from "./Goals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0cc5638')) {
      api.createRecord('b0cc5638', component.options)
    } else {
      api.reload('b0cc5638', component.options)
    }
    module.hot.accept("./Goals.vue?vue&type=template&id=b0cc5638", function () {
      api.rerender('b0cc5638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/Goals.vue"
export default component.exports